import { Component, OnInit ,ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { VoucherService } from "../shared/voucher.service";

@Component({
  selector: 'app-voucherapproval',
  templateUrl: './voucherapproval.component.html',
  styleUrls: ['./voucherapproval.component.css']
})

export class VoucherapprovalComponent implements OnInit {

  displayedColumns: string[] = ['Voucher Type', 'Voucher Date', 'Approval Status', 'Voucher Details', 'Action'];
  ListByApprovalStatus = 1; // selecting approval sp

  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private voucherService: VoucherService) {
    this.dataSource.paginator = this.paginator;
   }

  ngOnInit() {

    this.getVoucherList();
  }

  getVoucherList() {

    this.voucherService.FetchVoucherList(this.ListByApprovalStatus).subscribe(data => {
      this.dataSource.data = data;
    })
  }

  ApproveorReject(actionType: number, voucher: any) {

    voucher.Flag = 3; // ApprovalStatusId updation
    voucher.ApprovalStatusId = actionType; //  ApproveorReject

    this.voucherService.IUDVoucher(voucher)
      .toPromise()
      .then(data => {
        this.router.navigate(['/Voucherapproval']);
      })
      .catch(err => { console.log(err) });

    this.router.navigate(['/voucher', voucher.Id]);
  }
  
  View(actionType: number, voucher: any) {

    this.router.navigate(['/voucher', voucher.Id]);
  }

}
